/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconTeeth/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconTeeth({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconTeeth",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#fff",
  stroke = "#fff",
  fill3 = "#3E3A36"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconTeeth.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-n6Kis': alignSelf,'--mt-2-n6Kis': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-n6Kis': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-n6Kis': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-n6Kis': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-n6Kis': opacity,'--w-10-n6Kis': typeof width === 'number' ? `${width}px` : width,'--h-11-n6Kis': typeof height === 'number' ? `${height}px` : height,'--f-12-n6Kis': fill,'--a-7-n6Kis': isAnimated ? animation : "none",'--sd-8-n6Kis': isAnimated ? strokeDashoffset : 0,'--sd-9-n6Kis': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="TysiaIconTeeth.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_2409_8785)"
 className="views-block"
>
<path
  data-testid="TysiaIconTeeth.SvgPath"
  data-view-path={viewPath}
 d="M10.391 9.254l.193.689.193.689.293-.622.65-.224-.664-.266-.665-.266z"
 strokeWidth=".25"
 strokeMiterlimit={10}
 style={{'--f-12-n6Kis': fill2,'--s-13-n6Kis': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="TysiaIconTeeth.SvgPath:1"
  data-view-path={viewPath}
 d="M11.07 10.01l.477.53"
 strokeWidth=".25"
 strokeMiterlimit={10}
 style={{'--s-13-n6Kis': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
<path
  data-testid="TysiaIconTeeth.SvgPath:2"
  data-view-path={viewPath}
 d="M8 2.4a5.6 5.6 0 100 11.2A5.6 5.6 0 008 2.4z"
 style={{'--f-12-n6Kis': fill3}}
 className={`views-block ${styles.SvgPath2}`}
/>
<path
  data-testid="TysiaIconTeeth.SvgPath:3"
  data-view-path={viewPath}
 d="M6.861 9.476c.012-.137.031-.579.087-.695.069-.14.47-.17.722-.146.154.014.339.152.38.245M8.118 10.18c-.047.074-.184.13-.388.155-.468.059-.791-.081-.836-.414-.014-.104-.018-.054-.025-.165M8.126 10.119c.003.015.01.037.014.051.036.115.132.145.348.166.377.036.707-.109.789-.326l.034-.164v-.12M9.294 9.504V9.41l.008-.347c0-.252-.095-.407-.397-.403-.739.014-.847.04-.85.397l-.011.625M5.76 9.405c-.022.09.02.452-.406.496-.078.008-.224-.087-.254-.168a2.551 2.551 0 01-.133-.473c-.025-.033-.033-.067-.044-.037-.034.091-.103.183-.182.196-.076.009-.215-.089-.246-.17-.067-.176-.05-.38-.054-.552-.008-.223-.053-.353.182-.331.165.015.308.045.353.2.028-.062.085-.106.205-.12.268-.032.54.16.545.431"
 strokeWidth=".25"
 strokeMiterlimit={10}
 style={{'--s-13-n6Kis': stroke}}
 className={`views-block ${styles.SvgPath3}`}
/>
<path
  data-testid="TysiaIconTeeth.SvgPath:4"
  data-view-path={viewPath}
 d="M6.901 9.053c-.004-.145-.17-.372-.27-.406-.23-.076-.487-.065-.733-.075-.112.033-.163.245-.173.3l-.006.197M6.864 9.776c-.047.178-.248.273-.464.294-.263.025-.488-.06-.59-.33-.05-.13-.035-.275-.046-.367M9.299 9.086c.043-.445.333-.641.865-.576.118.014.382.23.396.35M10.535 9.509c.006.443-.42.715-.697.683a.653.653 0 01-.39-.189l-.13-.234"
 strokeWidth=".25"
 strokeMiterlimit={10}
 style={{'--s-13-n6Kis': stroke}}
 className={`views-block ${styles.SvgPath4}`}
/>
<path
  data-testid="TysiaIconTeeth.SvgPath:5"
  data-view-path={viewPath}
 d="M10.539 9.23c.02-.393.054-.846.388-.893a.342.342 0 01.18.011c.082-.056.282-.096.412-.121.034-.006.111.13.144.21.024.062.005.142.005.27-.016.113-.017.29-.072.45a.335.335 0 01-.232.192c-.043.007-.116-.032-.166-.078l-.012.121c-.025.202-.165.37-.397.338-.202-.03-.238-.078-.261-.265M8.08 6.844v-.01c.005-.035.017-.152.06-.298a.574.574 0 01.274-.342c.133-.062.293-.095.466-.095.138 0 .283.022.387.06.199.07.325.134.38.436l.004.056M8.066 7.969c.005.02.016.037.028.056a.356.356 0 00.185.121c.111.039.242.053.309.058l.157.001.287-.001h.002l.068.001c.05 0 .123-.003.203-.015.13-.02.3-.073.376-.204l.019-.954M8.066 7.969l-.005-.014M8.066 7.969l-.005.03M8.08 6.833v-.02M10.672 7.776c-.016.208-.414.24-.419.241 0 0-.09.008-.19.008A.747.747 0 019.842 8a.915.915 0 01-.143-.073M9.663 6.584c.028-.045.151-.326.383-.395.027-.008.159-.017.187-.017.057 0 .123.017.179.05.13.08.217.227.238.331M11.355 7.558c-.064.168-.15.277-.255.316a.265.265 0 01-.092.015.357.357 0 01-.162-.043 1.375 1.375 0 01-.191-.143M10.66 6.48c.025-.036.217-.28.403-.39a.316.316 0 01.156-.055c.016 0 .065.019.078.024.05.018.18.185.214.287"
 strokeWidth=".25"
 strokeMiterlimit={10}
 style={{'--s-13-n6Kis': stroke}}
 className={`views-block ${styles.SvgPath5}`}
/>
<path
  data-testid="TysiaIconTeeth.SvgPath:6"
  data-view-path={viewPath}
 d="M11.447 6.421c.073-.034.266-.17.359-.17h.005c.009.002.024.018.035.033.06.089.097.333.008.747-.073.344-.446.527-.547.552 0 0 .102-.605.102-.644M6.433 6.514c.316-.334.61-.45.953-.406.416.055.616.32.668.725M6.36 7.056l.03.476c-.016.5.257.623.718.642.29.013.722.053.94-.176l.021-.865M6.405 7.933c-.257.173-.789.156-.924-.168 0 0-.1-.474-.075-.773M6.565 6.502c-.19-.255-.874-.41-1.173-.064M4.762 7.485c.072.316.386.512.661.275M5.536 6.444c-.205-.244-.712-.438-.933.011"
 strokeWidth=".25"
 strokeMiterlimit={10}
 style={{'--s-13-n6Kis': stroke}}
 className={`views-block ${styles.SvgPath6}`}
/>
<path
  data-testid="TysiaIconTeeth.SvgPath:7"
  data-view-path={viewPath}
 d="M4.7 6.398c-.615-.528-.562.952.065 1.146L4.74 6.94M10.672 7.776s.047-.615.047-.758"
 strokeWidth=".25"
 strokeMiterlimit={10}
 style={{'--s-13-n6Kis': stroke}}
 className={`views-block ${styles.SvgPath7}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}